/* eslint-disable quotes */
/* eslint-disable no-shadow */
// Common
import "./lib/common/common.js";

// Load Web components
import "../components/kw-banner/kw-banner.js";
import "../components/kw-button-languages/kw-button-languages.js";
import "../components/kw-footer/kw-footer.js";
import "../components/kw-header/kw-header.js";
import "../components/kw-media-carousel/kw-media-carousel.js";
import "../components/kw-section/kw-section.js";
import "../components/kw-statistics/kw-statistics.js";
import "../components/kw-tab-list/kw-tab-list.js";
import "../components/kw-title/kw-title.js";
import "../components/kw-card-item/kw-card-item";
import "../components/kw-wrapper-cards/kw-wrapper-cards";

// Load scroll behavior to show/hide header
import "./lib/scroll/scroll.js";

import { CommonTpl } from "./pages/common.html.mjs";
import dataBanner from "./lib/dataBanner.js";
import data from "../json/index.json";

CommonTpl.setData(data);
CommonTpl.detectLanguage();

function banner() {
  const banner = document.getElementById("banner-homepage");
  banner.innerHTML = `
        <kw-banner id="Banner" CommonTpl.LANG="${CommonTpl.LANG}">
            ${CommonTpl.dataLanguage(data.banners)
    .map(dataBanner.banner)
    .join("")}
        </kw-banner>
  `;
}

function loadAnimation() {
  const playBannerAnimation = new CustomEvent("play-animation-banner", {
    detail: { id: "Banner" },
  });
  document.dispatchEvent(playBannerAnimation);
}

function imagesAnimation() {
  const section = document.querySelector("#WhySection");
  const imageOne = document.querySelector(".section__picture-lateral-left");
  const imageTwo = document.querySelector(".section__picture2-lateral-left");
  const imageThree = document.querySelector(".section__picture3-lateral-left");
  const description = document.querySelector(".desktop-description");

  const options = {
    threshold: 0.8,
  };
  /* eslint-disable-next-line */
  function callBack(entries, observer) {
    if (entries[0].isIntersecting) {
      if (description) {
        description.classList.add("move_ascension");
      }
      if (imageOne) {
        imageOne.classList.add("move_left-One");
      }
      if (imageTwo) {
        imageTwo.classList.add("move_left-Two");
      }
      if (imageThree) {
        imageThree.classList.add("move_left-Three");
      }
    }
  }

  const observerImages = new IntersectionObserver(callBack, options);
  observerImages.observe(section);
}

function greatPlaceToWorkSection() {
  const desktopSection = document.querySelector("#desktop-section");
  const mobileSection = document.querySelector("#mobile-section");
  if (window.innerWidth <= 768) {
    desktopSection.classList.add("hidden");
    mobileSection.classList.remove("hidden");
  }
  if (window.innerWidth >= 768) {
    mobileSection.classList.add("hidden");
    desktopSection.classList.remove("hidden");
  }
}

function moveElementScrollTab() {
  const KwWrapperCards = document.querySelector("kw-wrapper-cards");
  const href = window.location.hash;
  const hash = href.slice(1);
  const cardItem = KwWrapperCards.shadowRoot.querySelector(
    `[data-link="${hash}"]`,
  );
  const card = cardItem.shadowRoot.querySelectorAll(
    ".kw-card-item__capacity-text",
  );
  card.forEach((item) => {
    item.classList.add("capacity-text-active");
  });
  const { top } = cardItem.getBoundingClientRect();
  const { offsetTop } = cardItem;
  let offsetTopResponsive;
  if (window.innerWidth < 1029) {
    offsetTopResponsive = offsetTop - 70;
  } else {
    cardItem.requestPointerLock((resolve) => {
      resolve();
    });
    offsetTopResponsive = top + window.pageYOffset;
    setTimeout(() => {
      document.exitPointerLock();
    }, 700);
  }
  window.scroll({
    top: offsetTopResponsive,
    behavior: "smooth",
  });
}

function createCustomEvent() {
  const detail = { name: window.location.hash.slice(1) };
  const event = new CustomEvent("item:selected", {
    detail,
    bubbles: true,
    composed: true,
  });
  setTimeout(() => {
    moveElementScrollTab();
  }, 100);
  return event;
}

function changePathUrlHash(event) {
  const item = event.currentTarget;
  window.location = `#${item.id}`;
  item.dispatchEvent(createCustomEvent());
}

function addMenuListenerEvent() {
  const kwHeaderComponent = document.querySelector("kw-header");
  const itemChangeTab = kwHeaderComponent.shadowRoot.querySelectorAll(".link-itself");
  // eslint-disable-next-line no-restricted-syntax
  for (const item of itemChangeTab) {
    item.addEventListener("click", changePathUrlHash);
  }
}

function reloadTag() {
  const KwWrapperCards = document.querySelector("kw-wrapper-cards");
  const href = window.location.hash;
  const hash = href.slice(1);
  const tag = KwWrapperCards.shadowRoot.querySelector(`[data-link="${hash}"]`);
  if (tag !== null) {
    tag.dispatchEvent(createCustomEvent());
    tag.scrollIntoView({ block: "center", behavior: "smooth" });
  }
}

function handleLoadWindowFunctions() {
  banner();
  imagesAnimation();
  addMenuListenerEvent();
  greatPlaceToWorkSection();
  if (document.getElementById("Banner")) {
    if (document.getElementById("Banner").__bannerData.length > 1) {
      setTimeout(loadAnimation, 5000);
    }
  }

  reloadTag();
}

if (document.addEventListener) {
  window.addEventListener("load", handleLoadWindowFunctions);
}
